import { createSlice } from '@reduxjs/toolkit';

const initialState = {
  accountId: null,
  name: null,
  logoUrl: null,
  // Resolved URL for the tenant's favicon. Drives the collapsed-rail
  // icon in SidebarLogo (NOT auto-filled from logo — only set when
  // the workspace explicitly uploaded a favicon). The browser-tab
  // favicon is written separately to the DOM `<link>` element.
  favicon: null,
  primaryColor: null,
  domain: null,
  bannerHtml: null,
  bannerImageUrl: null,
  dashboardWidgetHtml: null,
  loading: false,
  error: null,
};

const accountSlice = createSlice({
  name: 'account',
  initialState,
  reducers: {
    setAccount: (state, action) => {
      state.accountId = action.payload.accountId;
      state.name = action.payload.name;
      state.logoUrl = action.payload.logoUrl;
      state.favicon = action.payload.favicon ?? null;
      state.primaryColor = action.payload.primaryColor;
      state.domain = action.payload.domain;
      state.bannerHtml = action.payload.bannerHtml ?? null;
      state.bannerImageUrl = action.payload.bannerImageUrl ?? null;
      state.dashboardWidgetHtml = action.payload.dashboardWidgetHtml ?? null;
      state.loading = false;
      state.error = null;
    },
    clearAccount: (state) => {
      state.accountId = null;
      state.name = null;
      state.logoUrl = null;
      state.favicon = null;
      state.primaryColor = null;
      state.domain = null;
      state.bannerHtml = null;
      state.bannerImageUrl = null;
      state.dashboardWidgetHtml = null;
      state.error = null;
    },
    setLoading: (state, action) => {
      state.loading = action.payload;
    },
    setError: (state, action) => {
      state.error = action.payload;
      state.loading = false;
    },
  },
});

export const { setAccount, clearAccount, setLoading, setError } = accountSlice.actions;

export default accountSlice.reducer;
